import React, { useState } from "react";
import Sidebar from "./Sidebar";
import NotificationBell from "./NotificationBell";
import MessageBell from "./MessageBell";
import BarSelector from "./BarSelector";
import ArtistSelector from "./ArtistSelector";
import { useUserRole } from "../../context/UserRoleContext";

const DashboardLayout = ({ children }) => {
  const [currentPage, setCurrentPage] = useState("dashboard");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { userData } = useUserRole();

  return (
    <div className="dashboard-with-sidebar">
      <Sidebar
        currentPage={currentPage}
        setPage={setCurrentPage}
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      <main className="main-content">
        {/* Mobile menu toggle */}
        <div className="mobile-header">
          <div className="mobile-header-left">
            <button
              className="mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
            <div className="mobile-header-selector">
              {userData?.role === "bar_owner" ? (
                <BarSelector />
              ) : userData?.role === "bar_admin" ? (
                <BarSelector showWhenNoBars emptyBarLabel="No bars assigned" />
              ) : userData?.role === "artist" ? (
                <ArtistSelector />
              ) : (
                <h2 className="mobile-title">Local Live Music</h2>
              )}
            </div>
          </div>

          <div className="mobile-header-right">
            <MessageBell />
            <NotificationBell />
          </div>
        </div>

        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;
